import { render } from "./DoctorShiftModal.vue?vue&type=template&id=66f38252&scoped=true"
import script from "./DoctorShiftModal.vue?vue&type=script&lang=js"
export * from "./DoctorShiftModal.vue?vue&type=script&lang=js"

import "./DoctorShiftModal.vue?vue&type=style&index=0&id=66f38252&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f38252"]])

export default __exports__